export const jobModule = {
  source: "Report - Module",
  causer: "Executed by",
  executedAt: "Executed at",
  finishedAt: "Finished at",
  launchBtn: "Start",
};
